import React from 'react';
import 'AppSrc/core/style/components/form/fields/popup-modal.css';


const PopUpModal = React.memo(() => {
  const contentItems = [
    {
      title: 'Planning',
      text: 'Did the change follow the approved implementation plan? e.g. clashes with the timing of the change',
    },
    {
      title: 'Delayed due to Incident or regressed/stopped',
      text: 'e.g. unrelated incident causing a delay to the start of the change had to stop the change due to a change freeze being imposed.',
    },
    {
      title: 'Preparation',
      text: 'e.g. due diligence around checking (peer review), design, pre-check/post-checks, incorrect implementation plan.',
    },
    {
      title: 'Execution',
      text: 'e.g. human error',
    },
    {
      title: 'Testing',
      text: 'e.g. bug in the software or something that should have been caught in testing or no testing had been done',
    },
  ];
  return (
    <div className="popup-modal-wrapper">
      <div className="content-body">
        <div className="content-item-wrap">
          {
            contentItems.map((item) => (
              <div className="content-item" key={item.title}>
                <div className="content-title">
                  {item.title}
                </div>
                <div className="content-text">
                  {item.text}
                </div>
              </div>
            ))
          }
        </div>
      </div>
    </div>
  );
});


export { PopUpModal };
